import React from 'react';

// Last-resort safety net: without this, any uncaught error during render (a null
// property access, a bad API response, etc.) unmounts the whole React tree and leaves
// a blank/black screen with no feedback and no way to recover other than a manual reload.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Erro não tratado capturado pelo ErrorBoundary', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
          width: '100%',
          textAlign: 'center',
          padding: '20px',
          boxSizing: 'border-box',
          fontFamily: 'sans-serif',
          color: '#333',
        }}>
          <h2 style={{ marginBottom: '10px' }}>Ops, algo deu errado</h2>
          <p style={{ marginBottom: '20px', color: '#666' }}>
            Ocorreu um erro inesperado ao carregar esta página. Tente recarregar.
          </p>
          <button
            onClick={this.handleReload}
            style={{
              padding: '10px 24px',
              cursor: 'pointer',
              border: 'none',
              borderRadius: '4px',
              backgroundColor: '#3498ff',
              color: '#fff',
              fontSize: '14px',
            }}
          >
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
